import PessoaFisica from './componentes/PessoaFisica.vue';
import Alterar from './componentes/Alterar.vue';
import Assinatura from './componentes/Assinatura.vue';
import IRPF from './componentes/IRPF.vue';
import GerarIRPF from './componentes/GerarIRPF.vue';
import AssinarDocumento from './componentes/AssinarDocumento.vue';

export default {
  path: 'pessoa-fisica',
  component: PessoaFisica,
  meta: { auth: true },
  children: [
    {
      path: 'alterar',
      name: 'pessoa-fisica.alterar',
      component: Alterar,
    },
    {
      path: 'assinatura',
      name: 'pessoa-fisica.assinatura',
      component: Assinatura,
    },
    {
      path: 'assinatura/assinar/:id',
      name: 'pessoa-fisica.assinatura.assinar',
      component: AssinarDocumento,
    },
    {
      path: 'irpf',
      name: 'pessoa-fisica.irpf',
      component: IRPF,
    },
    {
      path: 'irpf/gerar/:ano',
      name: 'pessoa-fisica.irpf.gerar',
      component: GerarIRPF,
    },
  ]
}



// WEBPACK FOOTER //
// ./FrontEnd/modulos/pessoa-fisica/rotas.js